import { atom } from "recoil";
export const respresentatAtom = atom({
  key: "respresentatAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
